    <div [hidden]="!ShowOpenApplications" *ngIf="isContractor() &&
              currentContact?.femaTrained &&
              toggleOpenClosedProjects" style="margin-top: 18px;">
      <h6 style="margin-left: 15px;">Open Projects</h6>
    </div>

  <div [hidden]="!ShowOpenApplications" >
    <div *ngIf="toggleDisplayCardList">
      <div fxLayout="row wrap" fxLayout.xs="column wrap" style="margin-top: 18px;">
        <div *ngFor="let application of data" fxFlex.gt-xs="50%" [fxFlex.gt-md]="cardLayout">
          <div style="margin-top: 10px; margin-right: 10px;">
            <mat-card [class.mat-elevation-z7]='true'>
              <!-- Card Title -->
              <mat-card-title style="font-size: 16px;">{{application.name}}</mat-card-title>
              <mat-card-subtitle class="card-subtitle">
                <span *ngIf="isContractorOnApp(application)">
                  Project number: {{application.applicationNumber}} ({{programTypeDesc(application.programType)}})
                </span>
                <span *ngIf="isHomeownerOnApp(application)">
                  Application number: {{application.applicationNumber}} ({{programTypeDesc(application.programType)}})
                </span>
              </mat-card-subtitle>
              <mat-divider></mat-divider>
              <!-- Card Body -->
              <div style="margin-top: 32px !important">
                <mat-card-content>
                  <div>
                    <span>
                      <span class="card-label">Program</span>
                      <span class="card-value">
                        {{application._Ebb_ProgramCycleId_Formatted}}
                        <br>
                        <span class="card-value-light">
                          (accepted {{getFormattedDate(application.acceptedDate.toString())}})
                        </span>
                      </span>
                    </span>
                  </div>
                  <div style="margin-top: 9px;">
                    <span>
                      <span class="card-label">Status</span>
                      <div *ngIf="application.stateCode === 0">
                        <div [ngSwitch]="application.stageCode">
                          <div *ngSwitchCase="700000000" class="card-value">
                            <span *ngIf="application.applicationStatusOptionSet !== 'Extension' && application.programType !== 700000002">
                              Pre-retrofit -
                            </span>
                            <span *ngIf="application.applicationStatusOptionSet === 'Extension'">Extension - {{application.extensionDate | date: 'M/d/yyyy'}}</span>
                             <span *ngIf="application.itemsRejectedRollup > 0 else showActivePreStageNoReject">
                              <span class="warn-text">
                                Action Required
                              </span>
                            </span>
                            <ng-template #showActivePreStageNoReject>
                              <span *ngIf='application.eventPreliminaryReview'>
                                <span *ngIf="application.programType !== 700000002">
                                  Submitted
                                </span>
                                <p *ngIf="application.programType === 700000002">
                                  FEMA Review <span> - </span> <span [innerHTML]="femareviewmessage"
                                    style=" display: inline-block;color: #377491;"></span>
                                </p>
                              </span>
                              <span *ngIf='!application.eventPreliminaryReview'>
                                <span *ngIf='isContractorOnApp(application) && !isHomeownerOnApp(application)' class="warn-text">
                                  Upload Documents
                                </span>
                                <span *ngIf='isHomeownerOnApp(application)'>
                                  <span *ngIf="application.applicationStatusOptionSet !== 'Extension'">In process</span>
                                   </span>
                              </span>
                            </ng-template>
                          </div>
                          <div *ngSwitchCase="700000001" class="card-value">
                            Post-retrofit -
                            <span *ngIf="application.itemsRejectedRollup > 0 else showActivePostStageNoReject">
                              <span class="warn-text">
                                Action Required
                              </span>
                            </span>
                            <ng-template #showActivePostStageNoReject>
                              <span *ngIf='application.eventApplicationSubmitted'>
                                Submitted
                              </span>
                              <span *ngIf='!application.eventApplicationSubmitted'>
                                <span class="accent-text">
                                  Proceed with Project
                                </span>
                              </span>
                            </ng-template>
                          </div>
                          <div *ngSwitchCase="700000002" class="card-value">
                            Application In Review
                            <span *ngIf="application.itemsRejectedRollup">
                              -
                              <span class="warn-text">
                                Action Required
                              </span>
                            </span>
                          </div>
                          <div *ngSwitchCase="700000003" class="card-value">
                            Application In Review
                            <span *ngIf="application.itemsRejectedRollup">
                              -
                              <span class="warn-text">
                                Action Required
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="application.stateCode === 1">
                        <div [ngSwitch]="application.statusCode">
                          <div *ngSwitchCase="700000000" class="card-value">
                            <span class="accent-text">
                              Paid
                            </span>
                          </div>
                          <div *ngSwitchCase="700000001" class="card-value">
                            <span class="accent-text">
                              Withdrawn
                            </span>
                          </div>

                        </div>
                      </div>
                    </span>
                  </div>
                  <div *ngIf="isHomeownerOnApp(application)" style="margin-top: 9px;">
                    <div [ngSwitch]="application.contractorTypeCode">
                      <div *ngSwitchCase="700000000">
                        <span>
                          <span class="card-label">Contractor</span>
                          <span
                            *ngIf='application._Ebb_ContractorId_Formatted && application._Ebb_ContractorId_Formatted.length > 0 else showSelectContractor'
                            class="card-value">
                            {{application?.contractor?.businessName ? application.contractor.businessName : application._Ebb_ContractorId_Formatted}}
                          </span>
                          <ng-template #showSelectContractor>
                            <span class="card-value">Contractor has not been selected</span>
                          </ng-template>
                        </span>
                      </div>
                      <div *ngSwitchCase="700000001">
                        <span>
                          <span class="card-label">Contractor</span>
                          <span class="card-value">Homeowner is doing retrofit</span>
                        </span>
                      </div>
                      <div *ngSwitchDefault>
                        <span>
                          <span class="card-label">Contractor</span>
                          <span class="card-value">Select a contractor <span class="card-value-light">(or do it yourself)</span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isContractorOnApp(application)" style="margin-top: 9px;">
                    <span>
                      <span class="card-label">Homeowner</span>
                      <span class="card-value">
                        {{application._Ebb_OwnerId_Formatted}}
                      </span>
                    </span>
                  </div>

                  <div *ngIf="isContractorOnApp(application) && application.contractorInvitationCode === 700000001" style="margin-top: 12px;">
                    <span class="card-label">
                      <span class="accent-text">NEW</span>
                    </span>
                    <span class="card-value">
                      Request to upload documents on behalf of this homeowner
                    </span>
                  </div>
                  <div style="margin-top: 12px;">
                    <span class="card-label">
                      To Do
                    </span>
                    <div *ngIf="application.itemsPendingRollup > 0">
                      <span class="card-value">
                        {{application.itemsPendingRollup}} item<span *ngIf="application.itemsPendingRollup > 1">s</span> due<span
                          *ngIf="application.itemsRejectedRollup > 0">;
                          {{application.itemsRejectedRollup}} item<span *ngIf="application.itemsRejectedRollup > 1">s</span> to correct</span>
                      </span>
                    </div>
                    <div *ngIf="application.itemsPendingRollup <= 0 && application.itemsRejectedRollup > 0">
                      <span class="card-value">
                        {{application.itemsRejectedRollup}} item<span *ngIf="application.itemsRejectedRollup > 1">s</span> to correct
                      </span>
                    </div>
                    <div *ngIf="application.itemsPendingRollup <= 0 && application.itemsRejectedRollup <= 0">
                      <span class="card-value">
                        No items currently due
                      </span>
                    </div>
                  </div>
                </mat-card-content>
              </div>
              <mat-divider></mat-divider>
              <!-- Card Actions -->
              <!-- 1: ALL Read-only; 2: Contractor Read-only; 3: ALL Edit -->
              <mat-card-actions>
                <div *ngIf='checkUserAuthorization(application.stageCode, application.contractorPermissionsCode, application._Ebb_OwnerId, application._Ebb_ContractorId) === 1 && application.stageCode <= 1'>
                  <button mat-stroked-button color="primary" (click)="onClickOpenApplication(application.id)">
                    VIEW
                  </button>
                </div>
                <div *ngIf='
                    checkUserAuthorization(application.stateCode, application.contractorPermissionsCode, application._Ebb_OwnerId, application._Ebb_ContractorId) === 1 &&
                    (application.stageCode === 700000003 &&
                    application.eventApplicationSubmitted === true &&
                    application.eventFinancialReviewSubmitted === true)
                  '
                >
                  <button mat-stroked-button color="primary" (click)="onClickOpenApplication(application.id)">
                    VIEW
                  </button>
                </div>
                <div *ngIf='checkUserAuthorization(application.stateCode, application.contractorPermissionsCode, application._Ebb_OwnerId, application._Ebb_ContractorId) === 2 '>
                  <button mat-stroked-button color="primary" (click)="onClickOpenApplication(application.id)">
                    VIEW
                  </button>
                </div>
                <div *ngIf='checkUserAuthorization(application.stateCode, application.contractorPermissionsCode, application._Ebb_OwnerId, application._Ebb_ContractorId) === 3 '>
                  <button mat-raised-button color="primary" (click)="onClickOpenApplication(application.id)">
                    EDIT
                  </button>
                </div>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
      </div>
    </div>

    <div class="mat-elevation-z7" style="width: 100%" [hidden]="toggleDisplayCardList">
      <table mat-table [dataSource]="dataSource" matSort matSortActive="_Ebb_OwnerId_Formatted" matSortDirection="asc" style="width: 100%">
        <ng-container matColumnDef="applicationNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Application Number </th>
          <td mat-cell width="8%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              {{item.applicationNumber}}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="_Ebb_OwnerId_Formatted">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Owner Name </th>
          <td mat-cell width="10%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              {{item._Ebb_OwnerId_Formatted}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
          <td mat-cell width="25%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              {{item.name}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="acceptedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Accepted date </th>
          <td mat-cell width="7%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              {{getFormattedDate(item.acceptedDate.toString())}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="displayretrofitdue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Phase Due Date </th>
          <td mat-cell width="7%;" *matCellDef="let item">
              <span style="font-size: 14px;">
                {{item.displayretrofitdue}}
              </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="_Ebb_ProgramCycleId_Formatted">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Program </th>
          <td mat-cell width="10%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              <div *ngIf="item">
                {{item._Ebb_ProgramCycleId_Formatted | Filename}}
              </div>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="_EBB_ProgramType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
          <td mat-cell width="10%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              <div *ngIf="item">
                {{programTypeDesc(item.programType)}}
              </div>
            </span>
          </td>
        </ng-container>


        <ng-container matColumnDef="displaystatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell width="25%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              <div *ngIf="isContractorOnApp(item) && item.stateCode === 0 ">
                <div [ngSwitch]="item.stageCode">
                  <div *ngSwitchCase="700000000" class="card-value">
                   {{item.displaystatus}}  <span *ngIf="item.displaystatus === 'Extension'"> - {{item.extensionDate | date: 'M/d/yyyy'}}</span><br />
                    <span *ngIf="item.itemsRejectedRollup > 0 else showActiveListPreStageNoReject">
                      <span class="warn-text">
                        Action Required
                      </span>
                    </span>
                    <ng-template #showActiveListPreStageNoReject>
                      <span *ngIf='item.eventPreliminaryReview'>
                        <span *ngIf="item.programType !== 700000002">
                          Submitted
                        </span>
                        <span *ngIf="item.programType === 700000002">
                          <!-- FEMA Review  <br/> -->
                          <span [innerHTML]="femareviewmessage" style=" display: inline-block;color: #377491;"></span>
                        </span>
                      </span>
                      <span *ngIf='!item.eventPreliminaryReview'>
                        <span *ngIf='isContractorOnApp(item) && !isHomeownerOnApp(item)' class="warn-text">
                          Upload Documents
                        </span>
                        <span *ngIf='isHomeownerOnApp(item)'>
                          <span *ngIf="item.applicationStatusOptionSet !== 'Extension'">In process</span>
                          <span *ngIf="item.applicationStatusOptionSet === 'Extension'">{{item.extensionDate | date: 'M/d/yyyy'}}</span>
                        </span>
                      </span>
                    </ng-template>
                  </div>
                  <div *ngSwitchCase="700000001" class="card-value">
                    {{item.displaystatus}} <br />
                    <span *ngIf="item.itemsRejectedRollup > 0 else showActiveListPostStageNoReject">
                      <span class="warn-text">
                        Action Required
                      </span>
                    </span>
                    <ng-template #showActiveListPostStageNoReject>
                      <span *ngIf='item.eventApplicationSubmitted'>
                        Submitted
                      </span>
                      <span *ngIf='!item.eventApplicationSubmitted'>
                        <span class="accent-text">
                          Proceed with Project
                        </span>
                      </span>
                    </ng-template>
                  </div>
                  <div *ngSwitchCase="700000002" class="card-value">
                   {{item.displaystatus}} <br />
                    <span *ngIf="item.itemsRejectedRollup">
                      <br/>
                      <span class="warn-text">
                        Action Required
                      </span>
                    </span>
                  </div>
                  <div *ngSwitchCase="700000003" class="card-value">
                   {{item.displaystatus}}
                    <span *ngIf="item.itemsRejectedRollup">
                      <br/>
                      <span class="warn-text">
                        Action Required
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="isContractorOnApp(item) && item.stateCode === 1">
                <div [ngSwitch]="item.statusCode">
                  <div *ngSwitchCase="700000000" class="card-value">
                    <span style="color: #2a7f48;">
                      {{item.displaystatus}}
                    </span>
                  </div>
                  <div *ngSwitchCase="700000001" class="card-value">
                    <span style="color: #2a7f48;">
                      {{item.displaystatus}}
                    </span>
                  </div>

                </div>
              </div>
              <div *ngIf="!isInspector()">
                <ng-template #showStatusForInspector>
                  {{item.displaystatus}}
                </ng-template>
              </div>

            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell width="10%;" *matCellDef="let item">         
            <div *ngIf="currentContact?.isContractor else showActionForInspector">
              <div *ngIf='checkUserAuthorization(item.stageCode, item.contractorPermissionsCode, item._Ebb_OwnerId, item._Ebb_ContractorId) === 1 && item.stageCode <= 1'>
                <button mat-stroked-button color="primary" (click)="onClickOpenApplication(item.id)">
                  VIEW
                </button>
              </div>
              <div *ngIf='
                  checkUserAuthorization(item.stateCode, item.contractorPermissionsCode, item._Ebb_OwnerId, item._Ebb_ContractorId) === 1 &&
                  (item.stageCode === 700000003 &&
                  item.eventApplicationSubmitted === true &&
                  item.eventFinancialReviewSubmitted === true)
                '
              >
                <button mat-stroked-button color="primary" (click)="onClickOpenApplication(item.id)">
                  VIEW
                </button>
              </div>
              <div *ngIf='checkUserAuthorization(item.stateCode, item.contractorPermissionsCode, item._Ebb_OwnerId, item._Ebb_ContractorId) === 2 '>
                <button mat-stroked-button color="primary" (click)="onClickOpenApplication(item.id)">
                  VIEW
                </button>
              </div>
              <div *ngIf='checkUserAuthorization(item.stateCode, item.contractorPermissionsCode, item._Ebb_OwnerId, item._Ebb_ContractorId) === 3 '>
                <button mat-raised-button color="primary" (click)="onClickOpenApplication(item.id)">
                  EDIT
                </button>
              </div>             
            </div>
            <ng-template #showActionForInspector>
              <button mat-stroked-button color="primary" (click)="onClickOpenApplication(item.id)">
                VIEW
              </button>
            </ng-template>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator #dataPaginatorOpen="matPaginator" [length]="dataSourceLength" [pageSizeOptions]="tablePageSizeOptions"></mat-paginator>
    </div>

  </div>

  <div *ngIf="ShowOpenApplicationsMessage" style="margin-top: 9px; margin-left: 15px;">
    <p>{{checkForOpenApplications}}</p>
  </div>
